(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ideal-image-hero-3"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var splideHero = new Splide('.splide-hero', {
      type: 'loop',
      gap: '10px',
      perMove: 1,
      perPage: 1,
      start: 0,
      autoplay: true,
      interval: 8000,
      pauseOnHover: true,
    });

    splideHero.mount();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ideal-info-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var splideInfo = new Splide('.splide-info', {
      type: 'loop',
      gap: '10px',
      perMove: 1,
      perPage: 1,
      start: 0,
      autoplay: true,
      interval: 8000,
      pauseOnHover: true,
    });

    splideInfo.mount();
  });

  } catch(e) { console.error(e); }
})();
})();
